/**
 * Полифил `Object.hasOwn` (ES2022) для старых webview.
 *
 * Корень (проверен end-to-end): @telegram-apps/transformers вызывает
 * `Object.hasOwn()` напролом внутри `retrieveLaunchParams()`. На старых
 * движках webview (некоторые версии Telegram для Android/старые системные
 * WebView) этого метода нет → бросает `LaunchParamsRetrieveError` → белый
 * экран у пользователя ещё до рендера React. esbuild/Vite не полифилят
 * методы стандартной библиотеки — только синтаксис, поэтому нужен ручной
 * рантайм-полифил, загруженный ДО любого кода, который тянет
 * @telegram-apps/* (это делает ./lib/tg.js).
 *
 * Side-effect-модуль без экспортов: импортируется в main.tsx самой первой
 * строкой (выше ./boot/armWatch.js), чтобы гарантированно выполниться
 * раньше SDK.
 *
 * Каст типа: под tsconfig (lib ES2022) TypeScript считает, что
 * `Object.hasOwn` уже существует в типах — поэтому обычное присваивание
 * `Object.hasOwn = ...` не проходит тайпчек без явного каста.
 */
if (!('hasOwn' in Object)) {
  (Object as { hasOwn?: (o: object, p: PropertyKey) => boolean }).hasOwn = (o, p) =>
    Object.prototype.hasOwnProperty.call(o, p);
}
